import { http } from './http';

export interface ApiDrawer {
  id: number;
  drawerName: string;
  drawerDescription?: string;
  drawerFolderFieldModelId?: number;
  drawerDocumentFieldModelId?: number;
  DrawerName?: string; DrawerDescription?: string; DrawerFolderFieldModelId?: number; DrawerDocumentFieldModelId?: number;
}

function normalizeDrawer(d:any): ApiDrawer {
  if (d.DrawerName && !d.drawerName) d.drawerName = d.DrawerName;
  if (d.DrawerDescription && !d.drawerDescription) d.drawerDescription = d.DrawerDescription;
  if (d.DrawerFolderFieldModelId && !d.drawerFolderFieldModelId) d.drawerFolderFieldModelId = d.DrawerFolderFieldModelId;
  if (d.DrawerDocumentFieldModelId && !d.drawerDocumentFieldModelId) d.drawerDocumentFieldModelId = d.DrawerDocumentFieldModelId;
  return d as ApiDrawer;
}

export async function getDrawers(): Promise<ApiDrawer[]> { const data = await http<any[]>('/api/drawer'); return Array.isArray(data)? data.map(normalizeDrawer):[]; }
export async function addDrawer(drawer: Omit<ApiDrawer,'id'>): Promise<ApiDrawer> { return normalizeDrawer(await http('/api/drawer',{method:'POST', json:drawer})); }
export async function updateDrawer(id:number, drawer: Omit<ApiDrawer,'id'>): Promise<void> { await http(`/api/drawer/${id}`,{method:'PUT', json:drawer}); }
export async function deleteDrawer(id:number): Promise<void> { await http(`/api/drawer/${id}`,{method:'DELETE'}); }
